import React, { useState } from 'react'
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import DashboardPendingCounts from './DashboardPendingCounts.js';
import DashboardPendingInternalStatusCounts from './DashboardPendingInternalStatusCounts.jsx';
import DashboardChartLicenseStatus from './DashboardChartLicenseStatus.js';
import RecentUpdatesV2 from './RecentUpdatesV2.jsx';
import DashboardChartApplicationStatusCounts from './DashboardChartApplicationStatusCounts.jsx';
import DashboardChartRenewalCountsByCycle from './DashboardChartRenewalCountsByCycle.jsx';
import DashboardChartReactivationStatus from './DashboardChartReactivationStatus.jsx';


function DashboardData() {

    return (
        <>
            <Row>
                <Col className="dashboardCard" style={{ height: '40vh', width: '30vw', margin: '1.25em' }}>
                    <DashboardPendingCounts />
                </Col>
                <Col className="dashboardCard" style={{ height: '40vh', width: '30vw', margin: '1.25em' }}>
                    <DashboardPendingInternalStatusCounts />
                </Col>
            </Row>
            <Row>
                <Col style={{ margin: '1.25em' }} className="dashboardCard">
                    <Row>
                        <Col style={{ position: 'relative', margin: 'auto', height: '40vh', width: '40vw', padding: '0 1.5em' }}>
                            <DashboardChartLicenseStatus />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col style={{ margin: '1.25em', padding: '0' }} className="dashboardCard">
                    <DashboardChartApplicationStatusCounts />
                </Col>
                <Col style={{ margin: '1.25em', padding: '0' }} className="dashboardCard">
                    <DashboardChartReactivationStatus />
                </Col>
            </Row>
            <Row>
                <Col style={{ margin: '1.25em', position: 'relative', height: '40vh', width: '40vw' }} className="dashboardCard">
                    <DashboardChartRenewalCountsByCycle />
                </Col>
            </Row>
            <Row>
                <Col style={{ margin: '1.25em', padding: '0' }} className="dashboardCard">
                    <RecentUpdatesV2 />
                </Col>
            </Row>
        </>

    )
}
export default DashboardData;